import { DashboardData } from './types';

export const COLORS: string[] = [];

export const CURRENCIES = [];

export const DEFAULT_EXPENDITURE_ENTRIES = [];

export const DEFAULT_INCOME_ENTRIES: { note: string; category: string }[] = [];

export const EXPENSE_CATEGORIES: string[] = [];

// Fallback data in case fetch fails
export const FALLBACK_DATA: DashboardData = {
  summary: {
    totalIncome: 0.0,
    totalExpenses: 0.0,
    balance: 0.0,
  },
  income: [],
  expenses: [],
  gifts: [],
};
